<template>
<div class="pa-0" style="overflow-x: hidden;">

    <v-container fluid class="my-4">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">


          <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>





          <home1 @funcionHijoPadre="recibirEnPadre" @funcionHijoPadreIngreso="recibirEnPadreIngreso"></home1>

          <br>

          <!-- <router-link :to="{name: 'about'}">USER</router-link> -->
        </v-col>
      </v-row>
    </v-container>

    


 <v-container fluid style="background-color:#F9F9F9">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <home-2 />

        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="background-color:#4C4A78">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <Home4Franja1/>
        </v-col>
      </v-row>
    </v-container>

    

     <v-container fluid class="my-4" ref="registerSection">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <UsuarioRegisterVue></UsuarioRegisterVue>
        </v-col>
      </v-row>
    </v-container>

  <v-container fluid style="background-color:#4C4A78">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <home-4 />
        </v-col>
      </v-row>
    </v-container>


     <v-container fluid style="background-color:#F9F9F9" ref="ingresoSection">
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <LoginFrame></LoginFrame>
        </v-col>
      </v-row>
    </v-container>

    

    <!-- <v-container fluid>
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
               <home5></home5>
        </v-col>
      </v-row>
    </v-container> -->

    <!-- <v-container fluid class="py-5" style="background-color:#F9F9F9">
      <v-row align="start" justify="start" >
        <v-col cols="12" md="10" offset-md="1" offset-lg="1">
          <p class="google-font mb-2" style="font-size:150%">Our Feature Event & Meetup</p>
        </v-col>
        <v-col cols="12" md="10" offset-md="1" offset-lg="1">
          <home-3 />
        </v-col>
      </v-row>
    </v-container> -->

    <!-- <v-container fluid>
      <v-row align="center" justify="center" class="fill-height">
        <v-col cols="12" md="10">
          <home-4 />
        </v-col>
      </v-row>
    </v-container> -->


    <!-- <v-row justify="end" >
        
        <v-col cols="2" >



        </v-col>
      </v-row> -->


  </div>

</template>
 
<script>


import home1 from "@/components/home/use/Home1.vue";

import home2 from "@/components/home/use/Home2.vue";


import home3 from "@/components/home/use/Home3.vue";


import home4 from "@/components/home/use/Home4.vue";

import Home4Franja1 from "@/components/home/use/Home4Franja1.vue";

import home5 from "@/components/home/use/Home5.vue";


import LoginFrame from '../components/usuario/LoginFrame.vue';



import UsuarioRegisterVue from '../components/auto_register/UsuarioRegister.vue';



import visitasService from "@/services/visitasService.js";


export default {
  data() {
    return {
      usuario:{
        recaptcha:''
      },
      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      }


    };
  },
  mounted(){

    this.setVisita();

  },
  components: {
   
    home1,
    home2,
    home3,
    home4,
    Home4Franja1,
    home5,
    LoginFrame,
    UsuarioRegisterVue
    
  },methods:{
    async recaptcha() {
  try {
    
    await this.$recaptchaLoaded();

    const token = await this.$recaptcha('login');

    
    return token;
  } catch (error) {
    console.error('Error al ejecutar reCAPTCHA:', error);
    throw error; 
  }
},

  async  setVisita(){


      try {
    const token = await this.recaptcha(); // Espera hasta que recaptcha() termine
  //  console.log('Token obtenido:', token);
          this.usuario.recaptcha=token;

        } catch (error) {
    console.error('Error en reCAPTCHA:', error);
  }




       visitasService.setVisita(this.usuario).then(respuesta=>{
          
          console.log("visita");

        })
        .catch(error => {
    if (error.response && error.response.data) {
      // Mostrar mensaje general
      console.log("Error:", error.response.data.message);



        let mensajeError = '';

          mensajeError += "\n"+"Error: "+error.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
      
      

      // Mostrar errores específicos de validación
      if (error.response.data.errors) {
        console.error("Errores de validación:", error.response.data.errors);
         let mensajeError = '';

          mensajeError += "\n"+"Error: "+error.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
      }
    } else {
      console.error("Error desconocido:", error);

       let mensajeError = '';

          mensajeError += "\n"+"Error: "+error.response.data.message;

            this.mensaje.text=mensajeError;

      this.mensaje.snackbar="true";

      this.mensaje.color="error";
      this.mensaje.colorBtn="error";
    }
  });

    },



  recibirEnPadre:function(){

      console.log('En elemento padre HOME');
       const registerSection = this.$refs.registerSection;
      if (registerSection) {
        registerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
 
    },
    recibirEnPadreIngreso:function(){

      console.log('En elemento padre HOME');
       const ingresoSection = this.$refs.ingresoSection;
      if (ingresoSection) {
        ingresoSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
 
    }

  }
};
</script>


